export default {
	waitDealConfirm: {
		en: "Successful Investment in the Project",
		ja: "プロジェクトへの投資の成功",
		ch: "等待交易確認"
	}
}
